import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'; // Importar Outlet
import { useAuth } from '../services/AuthContext';

const PrivateRoute = () => { // Remover a prop { element }
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />; // Usar Outlet para renderizar as rotas filhas
};

export default PrivateRoute;
